import { render, staticRenderFns } from "./bannerDesc.vue?vue&type=template&id=2348398c&scoped=true&"
import script from "./bannerDesc.vue?vue&type=script&lang=ts&"
export * from "./bannerDesc.vue?vue&type=script&lang=ts&"
import style0 from "./bannerDesc.vue?vue&type=style&index=0&id=2348398c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2348398c",
  null
  
)

export default component.exports